import styled, { css } from 'styled-components';
import { lighten, darken } from 'polished';

type ContainerProps = {
  variant: 'default' | 'outlined';
  loading?: string;
  full: boolean;
  disabled: boolean;
};

const containerStyles = {
  default: css`
    background-color: #329bfc;
    color: #ffffff;

    &:hover:not(:disabled) {
      background-color: ${darken(0.1, '#329bfc')};
    }

    &:disabled {
      background-color: rgba(0, 0, 0, 0.12);
    }
  `,
  outlined: css`
    outline: 2px solid #329bfc;
    outline-offset: -2px;

    &:hover:not(:disabled) {
      background-color: ${lighten(0.38, '#329bfc')};
    }

    &:disabled {
      outline-color: rgba(0, 0, 0, 0.12);
    }
  `,
};

export const Container = styled.button<ContainerProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 18px;
  border-radius: 5px;
  font-family: 'Sora', sans-serif;
  font-weight: 600;
  font-size: 15px;
  color: #329bfc;
  border: none;
  background-color: rgba(255, 255, 255, 0);
  cursor: pointer;

  span {
    display: flex;
    align-items: center;
  }

  &:disabled {
    cursor: not-allowed;
    color: rgba(0, 0, 0, 0.26);
  }

  ${({ variant }) => containerStyles[variant]};

  ${({ full }) =>
    full &&
    css`
      width: 100%;
    `};

  ${({ loading }) =>
    loading &&
    css`
      > span {
        visibility: hidden;
      }
    `};
`;

export const SpinnerContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
